/**
 * The entities a company custom field can be switched on for.
 *
 * One list for the admin API, the settings page and every plugin, so an entity
 * id is spelled the same everywhere. An entity is offered only while its plugin
 * is enabled for the company.
 */
export const CUSTOM_FIELD_ENTITIES = [
    { id: 'shipment', label: 'Shipments', pluginId: 'shipments' },
    { id: 'purchaseOrder', label: 'Purchase orders', pluginId: 'orders' },
    { id: 'purchaseOrderLine', label: 'Purchase order lines', pluginId: 'orders', line: true },
    { id: 'salesOrder', label: 'Sales orders', pluginId: 'orders' },
    { id: 'salesOrderLine', label: 'Sales order lines', pluginId: 'orders', line: true },
    { id: 'freightRfq', label: 'Freight RFQs', pluginId: 'freight-rfq' },
    { id: 'freightRfqLane', label: 'Freight RFQ lanes (award)', pluginId: 'freight-rfq', line: true },
    { id: 'rfq', label: 'RFQs', pluginId: 'rfq' },
    { id: 'workflowRequest', label: 'Workflow requests', pluginId: 'workflows' },
    { id: 'trf', label: 'TRFs', pluginId: 'temporary-permits' },
    { id: 'invoice', label: 'Invoices', pluginId: 'invoices' },
];
export const CUSTOM_FIELD_ENTITY_IDS = CUSTOM_FIELD_ENTITIES.map((entity) => entity.id);
export const isCustomFieldEntity = (id) => CUSTOM_FIELD_ENTITY_IDS.includes(id);
export const CUSTOM_FIELD_MANAGE_PERMISSION = 'admin:custom_field:manage';
/** Limits that keep a record's custom fields a few kilobytes, not megabytes. */
export const CUSTOM_FIELD_LIMITS = {
    fieldsPerCompany: 100,
    childrenPerGroup: 20,
    optionsPerField: 200,
    rowsPerGroup: 200,
    valuesPerList: 100,
    text: 500,
    textarea: 5000,
};
